import { gql } from "@apollo/client";

const updateAskAiChatSessionMutation = gql`
  mutation UpdateAskAiChatSessionMutation(
    $id: Int!
    $title: String
    $pinned: Boolean
  ) {
    updateChatSession(id: $id, title: $title, pinned: $pinned) {
      chatSession {
        id
        title
        pinnedAt
      }
    }
  }
`;

export default updateAskAiChatSessionMutation;
